module.exports = __webpack_public_path__ + "static/img/3_2_2.3c93ad18.png";